import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AddToCallListModal from 'components/modals/add_to_call_list_modal';

import { stopAddToCallList } from '../../store/actions/call_lists';
import { createBulkTask } from '../../store/actions/people';

import { getTargetContactIds, getTargetList, isAddingContactsToList } from '../../store/selectors/call_lists';
import { getDatabaseMembers } from '../../store/selectors/people';
import { getPeopleById } from '../../store/selectors/search';
import { getAvailableDatabases, getCurrentUser } from '../../store/selectors/static';

export class PeopleAddToCallListModal extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    callList: PropTypes.object,
    currentUser: PropTypes.object.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    people: PropTypes.objectOf(PropTypes.shape({
      id: PropTypes.number.isRequired
    })).isRequired,
    selectedPersonIds: PropTypes.array.isRequired,
    showModal: PropTypes.bool.isRequired,
    onAdd: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
  };

  handleAddToCallList = (data) => {
    const { selectedPersonIds, onAdd, onCancel } = this.props;
    onAdd(data, selectedPersonIds);
    onCancel();
  }

  render() {
    const {
      availableDatabases,
      callList,
      currentUser,
      selectedPersonIds,
      showModal,
      databaseMembers,
      onCancel
    } = this.props;

    const selectedContacts = [];
    selectedPersonIds.forEach((id) => {
      const person = this.props.people[id] || { id: id, unloaded: true };
      selectedContacts.push(person);
    });

    return (
      <AddToCallListModal
        availableDatabases={availableDatabases}
        callList={callList}
        currentUser={currentUser}
        databaseMembers={databaseMembers}
        defaultAssociatedModels={this.getDefaultAssociatedModels()}
        selectedContacts={selectedContacts}
        shown={showModal}
        onCancel={onCancel}
        onSubmit={this.handleAddToCallList}
      />
    );
  }

  getDefaultAssociatedModels() {
    return [
      {
        associatedModelId: 1,
        associatedModelType: "Multiple",
        name: "Multiple Contacts",
        default: true
      }
    ];
  }
}

const mapStateToProps = state => ({
  availableDatabases: getAvailableDatabases(state),
  callList: getTargetList(state),
  currentUser: getCurrentUser(state),
  databaseMembers: getDatabaseMembers(state),
  people: getPeopleById(state),
  selectedPersonIds: getTargetContactIds(state),
  showModal: isAddingContactsToList(state)
});

const mapDispatchToProps = {
  onAdd: createBulkTask,
  onCancel: stopAddToCallList,
};

export default connect(mapStateToProps, mapDispatchToProps)(PeopleAddToCallListModal);
